import * as api from "services/api";
import { getErrors } from "helpers/error";

export const GET_CHARGES = "[CHARGE] GET_CHARGES";
export const GET_CHARGES_SUCCESS = "[CHARGE] GET_CHARGES_SUCCESS";
export const GET_CHARGES_FAILED = "[CHARGE] GET_CHARGES_FAILED";

export const SET_VALUE = "[CHARGE EDIT] SET_VALUE";
export const CLEAR_VALUES = "[CHARGE EDIT] CLEAR_VALUES";

export function setValue(payload) {
	return { type: SET_VALUE, payload };
}

export function clearValues() {
	return { type: CLEAR_VALUES };
}

export function getCharges(
	skip,
	take,
	filter,
	sort,
	desc,
	toExport,
	callback
) {
	return async (dispatch, getState) => {
		dispatch({ type: GET_CHARGES });

		try {
			const { login } = getState();

			var response = await api.sendGet(
				`/Installment?skip=${skip}&take=${take}&sort=${sort}&desc=${desc}${
					filter || "&filters=null"
				}`,
				{
					Authorization: "Bearer " + login.token,
				}
			);

			let result = await response.json();

			if (result.isValid) {
				if (toExport) {
					dispatch(setValue({ loading: false }));
				} else {
					dispatch({
						type: GET_CHARGES_SUCCESS,
						payload: result.model,
					});

					if (result.params)
						dispatch(
							setValue({
								pages: Math.ceil(result.params.count / take),
								...result.params,
							})
						);
				}

				callback && callback(null, result.model);
			} else {
				const errors = getErrors(result.errors);

				dispatch({
					type: GET_CHARGES_FAILED,
					payload: errors,
				});
				callback && callback(errors);
			}
		} catch (error) {
			return dispatch({
				type: GET_CHARGES_FAILED,
				payload: {
					error: "Connection error",
				},
			});
		}
	};
}
